import React, { useRef, useState, useCallback, useEffect } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import QuillBetterTable from 'quill-better-table';
import 'quill-better-table/dist/quill-better-table.css';

// Register table module
Quill.register({
  'modules/better-table': QuillBetterTable
}, true);

const QuillEditor = ({ value, onChange, placeholder = "Írja ide a tartalmat..." }) => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);
  const [backendUrl] = useState(() => {
    const url = process.env.REACT_APP_BACKEND_URL || '';
    return url ? url.replace(/\/$/, '') : '';
  });

  // Image upload handler
  const imageHandler = useCallback(async () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/jpeg,image/png,image/gif,image/webp');
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (file) {
        const formData = new FormData();
        formData.append('image', file);

        try {
          const token = localStorage.getItem('adminToken');
          const response = await fetch(`${backendUrl}/api/uploads/blog/images`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`
            },
            body: formData
          });

          if (response.ok) {
            const data = await response.json();
            const quill = quillRef.current;
            const range = quill.getSelection();
            quill.insertEmbed(range.index, 'image', `${backendUrl}${data.url}`);
          } else {
            alert('Hiba a kép feltöltése során');
          }
        } catch (error) {
          console.error('Image upload error:', error);
          alert('Hiba a kép feltöltése során');
        }
      }
    };
  }, [backendUrl]);

  // Initialize Quill editor
  useEffect(() => {
    if (editorRef.current && !quillRef.current) {
      const quill = new Quill(editorRef.current, {
        theme: 'snow',
        placeholder,
        modules: {
          'better-table': {
            operationMenu: {
              items: {
                unmergeCells: { text: 'Cellák szétválasztása' },
                backgroundColor: { text: 'Háttérszín' },
                deleteColumn: { text: 'Oszlop törlése' },
                deleteRow: { text: 'Sor törlése' },
                insertColumnRight: { text: 'Oszlop beszúrása jobbra' },
                insertColumnLeft: { text: 'Oszlop beszúrása balra' },
                insertRowUp: { text: 'Sor beszúrása fölé' },
                insertRowDown: { text: 'Sor beszúrása alá' }
              }
            }
          },
          keyboard: {
            bindings: QuillBetterTable.keyboardBindings
          },
          toolbar: {
            container: [
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'font': [] }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'align': [] }],
              ['blockquote', 'code-block'],
              ['link', 'image'],
              [{ 'better-table': [] }],
              ['clean']
            ],
            handlers: {
              image: imageHandler,
              'better-table': function() {
                this.quill.getModule('better-table').insertTable(3, 3);
              }
            }
          }
        },
        formats: [
          'header', 'font', 'size',
          'bold', 'italic', 'underline', 'strike',
          'color', 'background',
          'script',
          'list', 'bullet', 'indent',
          'align',
          'blockquote', 'code-block',
          'link', 'image',
          'table', 'table-header', 'table-cell'
        ]
      });

      // Set initial content
      if (value) {
        quill.root.innerHTML = value;
      }

      // Listen for text changes
      quill.on('text-change', () => {
        const content = quill.root.innerHTML;
        onChange(content);
      });

      quillRef.current = quill;
    }
  }, [placeholder, imageHandler, onChange]);

  // Update content when value prop changes
  useEffect(() => {
    if (quillRef.current && value !== quillRef.current.root.innerHTML) {
      quillRef.current.root.innerHTML = value;
    }
  }, [value]);

  return (
    <div className="border border-gray-300 rounded-lg overflow-hidden">
      <div 
        ref={editorRef} 
        style={{ height: '400px', backgroundColor: 'white' }}
      />
      <div className="bg-gray-50 border-t border-gray-300 p-2 text-xs text-gray-600">
        <strong>Professzionális szerkesztő:</strong> Teljes formázás, képek, táblázatok, linkek és minden szükséges funkció
      </div>
    </div>
  );
};

export default QuillEditor;
